import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-nav-wrapper',
    templateUrl: './wdx-nav-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: {
        class: 'nav nav-tabs nav-flush flex-column text-center overflow-hidden flex-grow-1 flex-nowrap',
    },
})
export class WdxNavWrapperComponent {}
